import { render, staticRenderFns } from "./AccompagnementsMenu.vue?vue&type=template&id=02288ea6&"
import script from "./AccompagnementsMenu.vue?vue&type=script&lang=js&"
export * from "./AccompagnementsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports